import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import { colorPalette } from '../../../../../colorPalette';
export const IconWrapper = styled(Box)(() => ({
    width: '30px',
    height: '30px',
    padding: '8px',
    backgroundColor: colorPalette.gray100,
    borderRadius: '4px',
}));
export const InfoTypography = styled(Typography)(() => ({
    fontSize: '14px',
    color: colorPalette.gray700,
    lineHeight: '17px',
    wordWrap: 'break-word',
}));
